import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g fill="#2e3436"><path d="M5.01.014S4.302 0 3.563.37C2.825.739 2.01 1.68 2.01 3.014v3h2v-3c0-.666.186-.724.448-.855.261-.13.552-.145.552-.145h5v-2z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        whiteSpace: "normal",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" fillRule="evenodd" /><path d="M1.717 4.307L.303 5.721 3.01 8.428l2.707-2.707-1.414-1.414L3.01 5.6z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        whiteSpace: "normal",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1,
        marker: "none"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" /><path d="M5.01 5.014v-1h1v1zm-5 0v-1h1v1z" style={{
        marker: "none"
      }} color="#000" overflow="visible" /><path d="M.01 5.014c0-.554.446-1 1-1s1 .446 1 1-.446 1-1 1-1-.446-1-1zm4 0c0-.554.446-1 1-1s1 .446 1 1-.446 1-1 1-1-.446-1-1z" style={{
        marker: "none"
      }} color="#000" overflow="visible" /><path d="M2.01 11.014l6.518-6.572 3 3-6.518 6.572h-3z" fillRule="evenodd" /><path d="M11.637 1.676c-.2 0-.4.077-.554.23l-1.77 1.768 3.053 3.053 1.77-1.77a.783.783 0 000-1.109l-1.944-1.941a.782.782 0 00-.555-.23z" style={{
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1,
        marker: "none"
      }} color="#000" overflow="visible" fillRule="evenodd" /></g></svg>;
}

export default SvgComponent;